import { ApiOutlined, PlusOutlined } from "@ant-design/icons";
import { PageHeader } from "@ant-design/pro-components";
import { Button, Popconfirm, message } from "antd";
import { useEffect, useRef, useState } from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../api/api";
import ConditionBlock from "../../../Components/ConditionBlock/ConditionBlock";
import Loading from "../../../Components/Loading/Loading";
import ExportConditionsPdf from "../../../Util/ExportConditionsPdf";
import styles from "./UserQuestions.module.css";

const ConditionsManager = () => {
  const [arrayOfConditions, setArrayOfConditions] = useState(null);
  const [arrayOfConditionsClone, setArrayOfConditionsClone] = useState(null);
  const [questions, setQuestions] = useState();
  const [newBlockId, setNewBlockId] = useState(0);
  const [newConditionId, setNewConditionId] = useState(0);
  const [newThenId, setNewThenId] = useState(0);
  const [updateForcer, setUpdateForcer] = useState(0);
  const [formChanged, setFormChanged] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const conditionsContainer = useRef();
  const navigate = useNavigate();
  const { key } = useParams();

  const loadConditions = () => {
    let biggetBlockId = 0;
    let biggestConditionId = 0;
    let biggestThenId = 0;
    setLoadError(false);
    setArrayOfConditions(null);
    api
      .get(`/forms/${key}`)
      .then((res) => {
        const conditions = res.data.conditions || [];
        setQuestions(res.data.questions);
        setArrayOfConditions(conditions);
        setArrayOfConditionsClone(conditions);

        return conditions;
      })
      .then((conditions) => {
        conditions.forEach((block) => {
          if (+block.id > +biggetBlockId) {
            biggetBlockId = block.id;
          }
          block.condition.forEach((con) => {
            if (+con.id > +biggestConditionId) {
              biggestConditionId = con.id;
            }
          });
          block.then.forEach((t) => {
            if (+t.id > +biggestThenId) {
              biggestThenId = t.id;
            }
          });
        });
        setNewConditionId(biggestConditionId + 1);
        setNewBlockId(biggetBlockId + 1);
        setNewThenId(biggestThenId + 1);
      })
      .catch(() => {
        setLoadError(true);
        message.error("خطا در دریافت شروط");
      });
  };

  useEffect(() => {
    loadConditions();
  }, []);

  const validateDuplicate = () => {
    return arrayOfConditions?.some((condEl) =>
      condEl.then.some((thenEl) =>
        arrayOfConditions?.some((cond) =>
          cond.then.find(
            (e) =>
              e.id !== thenEl.id &&
              e.target.questionId == thenEl.target.questionId &&
              e.target.answerId == thenEl.target.answerId
          )
        )
      )
    );
  };

  const saveConditions = () => {
    const err = validateDuplicate();
    if (err) {
      message.error("ناهماهنگی در شروط");
      return;
    }

    if (loading) return;
    setLoading(true);
    api
      .put(`/forms/${key}`, { conditions: arrayOfConditions })
      .then(() => {
        setFormChanged(false);
        message.success("شروط با موفقیت آپدیت شد.");
      })
      .catch(() => message.error("خطا در آپدیت شروط"))
      .finally(() => setLoading(false));
  };

  const exportPdf = () => {
    const scroller = conditionsContainer.current?.querySelector(
      `.${styles.ConditionsContainer}`
    );
    if (!scroller || !arrayOfConditions?.length) {
      message.warning("شرطی برای خروجی گرفتن وجود ندارد");
      return;
    }
    if (pdfLoading) return;
    setPdfLoading(true);
    ExportConditionsPdf(scroller, `conditions-${key}`)
      .then(() => message.success("خروجی PDF ساخته شد"))
      .catch(() => message.error("خطا در ساخت خروجی PDF"))
      .finally(() => setPdfLoading(false));
  };

  const onChange = (field, blockId, value) => {
    setFormChanged(true);
    const newArrayOfConditions = JSON.parse(JSON.stringify(arrayOfConditions));
    newArrayOfConditions.map((block) => {
      if (block.id === blockId) {
        block[field] = value;
      }
      return block;
    });
    setArrayOfConditions(newArrayOfConditions);
  };

  const addBlock = () => {
    setFormChanged(true);
    const newArrayOfConditions = Array.from(arrayOfConditions);
    newArrayOfConditions.push({
      condition: [],
      id: newBlockId,
      then: [],
      type: "OR",
    });
    setNewBlockId((value) => value + 1);
    setArrayOfConditions(newArrayOfConditions);
  };

  const removeBlock = (blockId) => {
    setFormChanged(true);
    const newArrayOfConditions = [];
    JSON.parse(JSON.stringify(arrayOfConditions)).forEach((block) => {
      if (block.id !== blockId) {
        newArrayOfConditions.push(block);
      }
    });
    setArrayOfConditions(newArrayOfConditions);
  };

  const onDragEnd = (result) => {
    setFormChanged(true);
    const { destination, source, draggableId } = result;

    if (source.droppableId === destination.droppableId) {
      // const sourceFlag = newTermFlags[source.index];
      const newArrayOfConditions = Array.from(arrayOfConditions);
      const [removed] = newArrayOfConditions.splice(source.index, 1);
      newArrayOfConditions.splice(destination.index, 0, removed);
      const finalArray = JSON.parse(JSON.stringify(newArrayOfConditions));
      // setarrayOfConditions([]);
      setUpdateForcer(updateForcer + 1);
      setTimeout(() => {
        setArrayOfConditions(finalArray);
      }, 1);
    }

    setUpdateForcer(updateForcer + 1);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <PageHeader
        title="شروط"
        avatar={{ icon: <ApiOutlined /> }}
        extra={
          <>
            <Button onClick={() => navigate(`/question/${key}`)}>سوالات</Button>

            <Button icon={<PlusOutlined />} onClick={addBlock}>
              ساخت بلوک جدید
            </Button>

            <Button onClick={exportPdf} disabled={pdfLoading}>
              {pdfLoading ? "در حال ساخت PDF" : "خروجی PDF شروط"}
            </Button>

            <Popconfirm
              onConfirm={saveConditions}
              title={`آیا از ذخیره شروط مطمئن هستید؟`}
            >
              <Button
                disabled={loading}
                className={[
                  formChanged ? styles.FlashingSaveButton : null,
                ].join(" ")}
              >
                {loading ? "در حال ذخیره" : "ذخیره"}
              </Button>
            </Popconfirm>
          </>
        }
      />
      <div className={styles.UserCondtions} ref={conditionsContainer}>
        <ConditionsContainer>
          {Array.isArray(arrayOfConditions) ? (
            arrayOfConditions.map((block, index) => {
              const blockProps = {
                setNewBlockId,
                newBlockId,
                setNewConditionId,
                newConditionId,
                setNewThenId,
                newThenId,
                onChange: (field, value) => {
                  onChange(field, block.id, value);
                },
                removeBlock: () => {
                  removeBlock(block.id);
                },
                index,
                questions,
                ...block,
              };

              return (
                <ConditionBlock
                  {...blockProps}
                  key={block.id}
                  block={block}
                  conditionsClone={arrayOfConditionsClone}
                  arrayOfConditions={arrayOfConditions}
                />
              );
            })
          ) : loadError ? (
            <div style={{ textAlign: "center", padding: "2rem", color: "#999" }}>
              <p>خطا در دریافت شروط.</p>
              <Button onClick={loadConditions}>تلاش مجدد</Button>
            </div>
          ) : (
            <Loading />
          )}
        </ConditionsContainer>
      </div>
    </DragDropContext>
  );
};

const ConditionsContainer = ({ children }) => {
  return (
    <Droppable droppableId="ConditionsContainer">
      {(provided) => {
        return (
          <div className={styles.ConditionsContainer}>
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {children}
              {provided.placeholder}
            </div>
          </div>
        );
      }}
    </Droppable>
  );
};
export default ConditionsManager;
